import React, { useState, useEffect } from 'react';
import { iconToEmoji } from '../utils/iconUtils';

const IconSelector = ({ selectedIcon, onIconChange, isOpen = false }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [icons, setIcons] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Lade Icons direkt aus dem Frontend-Ordner
  useEffect(() => {
    const loadIcons = () => {
      const iconFiles = [
        'Adelhozener.png',
        'Augustiner.png',
        'beer.png',
        'bier_krug.png',
        'cocktail.png',
        'cola.png',
        'giesinger.png',
        'goasnmass.png',
        'schnaps.png',
        'spezi.png',
        'tegernseer.png',
        'wasser.png',
        'wein_rot_weiss.png',
        'weissbier.png',
        'white_monster.png',
        'wildbraeu.png'
      ];

      const icons = iconFiles.map(filename => {
        const name = filename.replace('.png', '');
        const displayName = name.replace('-', ' ').replace('_', ' ').replace(/([A-Z])/g, ' $1').trim();
        return {
          value: filename,
          label: displayName
        };
      });

      console.log('Geladene Icons:', icons);
      setIcons(icons);
      setIsLoading(false);
    };

    // Nur laden wenn Modal geöffnet ist
    if (isOpen) {
      loadIcons();
    } else {
      setIsLoading(false);
      setIcons([{ value: 'beer.png', label: 'Bier' }]);
    }
  }, [isOpen]);

  const handleIconSelect = (icon) => {
    onIconChange(icon);
    setShowDropdown(false);
  };

  const getDisplayIcon = () => {
    // Versuche zuerst das echte Icon zu laden
    const iconPath = `/icons/drinks/${selectedIcon}`;
    
    return (
      <div className="w-6 h-6 flex items-center justify-center">
        <img 
          src={iconPath} 
          alt={selectedIcon} 
          className="w-6 h-6 object-contain"
          onError={(e) => {
            // Fallback auf Emoji wenn PNG nicht gefunden
            console.log('Icon nicht gefunden:', iconPath);
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'block';
          }}
        />
        <span className="text-xl hidden">{iconToEmoji(selectedIcon)}</span>
      </div>
    );
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setShowDropdown(!showDropdown)}
        className="flex items-center gap-2 px-3 py-2 border border-accent-2 rounded-lg bg-white hover:bg-accent-1/5 transition-colors"
      >
        {getDisplayIcon()}
        <span className="text-sm text-text-normal">▼</span>
      </button>

      {/* Icon Dropdown */}
      {showDropdown && (
        <div className="absolute top-full left-0 mt-1 bg-white border border-accent-2 rounded-lg shadow-lg z-50 max-w-md">
                            {/* Icons Grid */}
                  <div className="p-3 max-h-60 overflow-y-auto">
                    {isLoading ? (
                      <div className="flex justify-center py-4">
                        <div className="animate-spin rounded-full h-6 w-6 border-2 border-accent-1 border-t-transparent"></div>
                      </div>
                    ) : (
                      <div className="space-y-2">
                        {icons.map((icon, index) => (
                          <button
                            key={index}
                            onClick={() => handleIconSelect(icon.value)}
                            className="w-full flex items-center gap-3 p-3 hover:bg-accent-1/10 rounded-lg transition-colors text-left group"
                            title={icon.label}
                          >
                            <div className="flex-shrink-0">
                              <img 
                                src={`/icons/drinks/${icon.value}`} 
                                alt={icon.label}
                                className="w-8 h-8 object-contain"
                                onError={(e) => {
                                  // Fallback auf Emoji wenn PNG nicht gefunden
                                  console.log('Icon nicht gefunden:', `/icons/drinks/${icon.value}`);
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'block';
                                }}
                              />
                              <span className="text-2xl hidden">{iconToEmoji(icon.value)}</span>
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="text-sm font-medium text-text-normal group-hover:text-text-strong truncate">
                                {icon.label}
                              </div>
                              <div className="text-xs text-text-subtle truncate">
                                {icon.value}
                              </div>
                            </div>
                          </button>
                        ))}
                      </div>
                        )}
                      </div>
        </div>
      )}

      {/* Backdrop */}
      {showDropdown && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setShowDropdown(false)}
        />
      )}
    </div>
  );
};

export default IconSelector;
